import { BaseModel } from 'core/models/base.model.js';

/**
 *  Model for loading the type hierarchy
 */
export var NiveauTypeHierarchieModel = BaseModel.extend({

  habilitationV: "PAR_ACTHIE.V",
  usecase: "activite",

  /**
   * Model for loading each activite
   */

  defaults: {
    "niveau": null,
    "libelle": "",
    "genre": "",
    "style": {
      "code": "",
      "libelle": "",
      "affichage": ""
    },
    "format": "",
    "transverse": "",
    "horsregr": "",
    "rechref": "",
    "saisieexp": "",
    "rechrexp": "",
    "grpcarpersodef": "",
    "grpcarpersodefhisto": "",
    "grpcarpersosai": ""
  },

  parse: function(response) {
    if (response) {
      if (response.code !== undefined) {
        response.id = response.code;
      }
      if (String(response.code) === "0") {
        response.id = "0";
      }
    }
    return response;
  }
});
